export enum AccomodationCategoryEnum {
  HOST_FAMILY = 'HOST_FAMILY',
  COLLEGE_CAMPUS_RESIDENCE = 'COLLEGE_CAMPUS_RESIDENCE'
}

export const accomodationCategoryEnumMapping: Record<AccomodationCategoryEnum, string> = {
  HOST_FAMILY: 'Famille-hôtesse',
  COLLEGE_CAMPUS_RESIDENCE: 'Collège, Campus & Résidence'
}
